import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import { ref, Ref, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { 
  'POST/checkin/owner_detail': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height 
} = new tbMix(fetchList)

let userRows: any = ref([])
const fetchHandle = async (params: object) => {
  await fetchData(params)

}

const searchConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: dayjs().subtract(0, 'month').format('YYYY-MM') + '-01',
    upKey: 'date',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD'
    }
  },
])



// -----
const formatDeatils = (rowArr: any, label: string) => {
  let obj = rowArr.find( (details: any) => details.label === label)
  return obj ? obj.time : '-'
  
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点此搜索考勤详情" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: fetchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 60 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(`${ row.realName }(${row.alias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "全勤奖",
          prop: "FullAwardAmount",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "迟到早退(分钟)",
          prop: "absenceMinutes",
          align: "right",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "事假(小时)",
          prop: "compassionateTime",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "病假(小时)",
          prop: "sickTime",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "加班换薪",
          prop: "overtimeSalary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "总时长",
              prop: "overtimeSalary.totalTime",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "工作日",
              formatter: (row) => formatDeatils(row.overtimeSalary.detailList, '工作日'),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "假日",
              formatter: (row) => formatDeatils(row.overtimeSalary.detailList, '假日'),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "节日",
              formatter: (row) => formatDeatils(row.overtimeSalary.detailList, '节日'),
              align: "right"
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "调休假换薪",
          prop: "adjustSalary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "总时长",
              prop: "adjustSalary.totalTime",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "工作日",
              formatter: (row) => formatDeatils(row.adjustSalary.detailList, '工作日'),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "假日",
              formatter: (row) => formatDeatils(row.adjustSalary.detailList, '假日'),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "节日",
              formatter: (row) => formatDeatils(row.adjustSalary.detailList, '节日'),
              align: "right"
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "年假换薪(小时)",
          prop: "annualTime",
          align: "right",
          width: "150"
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ])
  ]))
}
}

})